import API from "..";

import { TAuthenticate, TAuthResponse } from "./interfaces/auth";

const authenticate: TAuthenticate = (username, password) =>
  API.post<TAuthResponse>("/login_check", {
    username,
    password,
  }).then(({ data }) => data);
export default authenticate;
